import { createI18n } from 'vue-i18n';
import { DEFAULT_LANGUAGE } from '../utils/constants';
import zhCN from '../locales/zh-CN.yaml';
import enUS from '../locales/en-US.yaml';

export type I18n = ReturnType<typeof createI18n>;

const i18n = createI18n({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: {
    'en-US': [DEFAULT_LANGUAGE],
  },
  legacy: false,
  allowComposition: true,
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
  },
}) as I18n;

export default i18n;
